import {
    Component,
    OnInit,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    Optional,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SearchListingFilterPageComponent } from 'src/app/search-listing-filter-page/search-listing-filter-page.component';

import { Style } from '../../@shared/models/style.model';

@Component({
    selector: 'app-search-style-item',
    templateUrl: './search-style-item.component.html',
    styleUrls: ['./search-style-item.component.scss'],
})
export class SearchStyleItemComponent implements OnChanges {
    @Input() style: Style = new Style();
    @Input() radius: 'small' | 'normal' | 'large' = 'small';
    @Input() margin = 0;
    @Input() hideTitle = false;

    @Output() processEvent: EventEmitter<string> = new EventEmitter();

    private readonly STYLE_CSS_PREFIX = 'style-item-';
    private readonly HOVER_CSS_PREFIX = 'image-hover-';

    imageCSSClasses = '';
    textCSSClasses = '';
    hoverImageClasses = '';
    imageActiveBorderClass = '';

    imageBorderClass = '';

    constructor(
        @Optional()
        private dialogRef: MatDialogRef<SearchListingFilterPageComponent>
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        this.hoverImageClasses = this.HOVER_CSS_PREFIX + this.radius;
        const imageClasses = [
            this.STYLE_CSS_PREFIX + this.radius,
            this.style.active
                ? 'style-item-image-active'
                : 'style-item-image-inactive',
            this.style.active
                ? this.STYLE_CSS_PREFIX + this.radius + '__active'
                : '',
            this.hoverImageClasses,
        ];
        this.imageBorderClass =
            this.STYLE_CSS_PREFIX + this.radius + '__active';
        this.imageActiveBorderClass =
            this.STYLE_CSS_PREFIX + this.radius + '__active-border';
        this.imageCSSClasses = imageClasses.join(' ');

        const textClasses = [
            'style-item-text',
            this.STYLE_CSS_PREFIX + this.radius,
        ];
        this.textCSSClasses = textClasses.join(' ');
    }

    process(link: string) {
        this.processEvent.emit(link);
    }
    closeDialog() {
        this.dialogRef?.close();
    }
}
